<script lang="ts" generics="Item">
	import type { EmblaCarouselType } from "embla-carousel";
	import chevron from "@core/assets/icons/chevron.svg?raw";
	import PlusMinusButton from "./PlusMinusButton.svelte";
	import Carousel from "./common/Carousel.svelte";
	import type { CarouselWithArrowsProps } from "./common/CarouselProps.js";
	import Icon from "./common/Icon.svelte";

	const { wrapperClass, ...props }: CarouselWithArrowsProps<Item> = $props();

	let api = $state<EmblaCarouselType>();
	let canNext = $state(false);
	let canPrev = $state(false);
	let activeIndex = $state<number>(0);
	let width = $state(0);

	$effect(() => {
		const mountedApi = api;
		if (!mountedApi) {
			return;
		}
		const slideCount = props.items.length;
		function select(api: EmblaCarouselType): void {
			const slidesInView = api.slidesInView().map((inViewIndex) => inViewIndex % slideCount);
			activeIndex =
				slidesInView.reduce<number | null>((acc, curr, _, array) => {
					let previousIndex = curr - 1;
					if (previousIndex < 0) {
						previousIndex = props.items.length - 1;
					}
					if (array.includes(previousIndex)) {
						return acc;
					}
					return acc === null || curr < acc ? curr : acc;
				}, null) ?? 0;
		}
		mountedApi.on("slidesInView", select);
		select(mountedApi);
		return (): void => {
			mountedApi.off("slidesInView", select);
		};
	});
</script>

<svelte:window bind:innerWidth={width} />

<div class={["flex flex-col gap-6", wrapperClass]}>
	<Carousel bind:api bind:canNext bind:canPrev {...props} />
	{#if canNext || canPrev}
		<div class="flex text-nov-dark justify-center gap-6 items-center">
			<PlusMinusButton
				onclick={(): void => {
					api?.scrollPrev();
				}}
				disabled={!canPrev}
				kind="custom"
			>
				<Icon icon={chevron} class="rotate-180 size-3" />
			</PlusMinusButton>
			<div class="hidden gap-2 items-center bg-nov-light-100 rounded-xl px-4 py-2 xs:flex">
				{#each props.items as item, index (item)}
					{@const isActive = activeIndex === index}
					<button
						class={["h-2 rounded-lg w-2 relative", isActive ? "bg-nov-red-300 w-14" : "bg-nov-light-200 "]}
						aria-label="Přejít na snímek {index + 1}"
						onclick={(): void => api?.scrollTo(index)}
					></button>
				{/each}
			</div>
			<PlusMinusButton
				onclick={(): void => {
					api?.scrollNext();
				}}
				disabled={!canNext}
				kind="custom"
			>
				<Icon icon={chevron} class="size-3" />
			</PlusMinusButton>
		</div>
	{/if}
</div>
